import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { map, catchError, switchMap } from 'rxjs/operators';
import { of } from 'rxjs';
import { StoreService } from '../../core/store/store.service';
import { StoreStatusType } from '../../core/identity/constant/store-status-type.enum';
import { HttpErrorResponse } from '@angular/common/http';
import { AuthenticationService } from '../authentication/authentication.service';

@Injectable({
  providedIn: 'root'
})
export class IsStoreOpenGuard {

  constructor(
    private storeService: StoreService,
    private router: Router,
    private authService: AuthenticationService
  ) {}

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean | UrlTree> {
    const storeUuid = route.paramMap.get('uuid');
    
    if (!storeUuid) {
      return of(this.router.parseUrl('/'));
    }

    return this.authService.isAuthenticated().pipe(
      switchMap(isAuth => {
        if (!isAuth) {
          return of(this.router.parseUrl('/auth/login'));
        }
        
        return this.storeService.findOne(storeUuid).pipe(
          map(store => {
            if (store?.currentStatus?.type?.systemName === StoreStatusType.OPEN || store?.currentStatus?.type?.systemName === StoreStatusType.REMODEL) {
              return true;
            }
            return this.router.parseUrl('/');
          }),
          catchError((error: HttpErrorResponse) => {
            if (error.status === 401) {
              return of(this.router.parseUrl('/auth/login'));
            }
            return of(this.router.parseUrl('/'));
          })
        );
      })
    );
  }
}